// Does this browser draw a flag emoji as one glyph? Windows draws it as two
// letters. Checked once, with canvas text metrics.

import { LOCATIONS } from '@/lib/locations'
import { flagIsOneGlyph } from './probe-blips-math'

let cached: boolean | undefined

export function flagsDrawn(): boolean {
  if (cached !== undefined) return cached
  const ctx = typeof document === 'undefined' ? null : document.createElement('canvas').getContext('2d')
  // No canvas: assume flags are drawn.
  if (ctx) ctx.font = '16px sans-serif'
  cached = ctx ? flagIsOneGlyph((t) => ctx.measureText(t).width, LOCATIONS[0].flag) : true
  return cached
}

/** For tests. */
export function resetFlagSupport() {
  cached = undefined
}
